import EditIcon from '@mui/icons-material/Edit'
import { IconButton, IconButtonProps } from '@mui/material'
import React from 'react'

interface NewEditButtonProps extends IconButtonProps {
  to?: string // If button should act as a link
}

export default function NewEditButton(props: NewEditButtonProps) {
  return (
    <IconButton {...props}>
      <EditIcon />
    </IconButton>
  )
}
